import { combineReducers } from '@reduxjs/toolkit';
import { IStore } from '../types';
import topic from './topic';
import answer from './answer';

const rootReducer = combineReducers<IStore>({
    topic, answer,
});

export default rootReducer;